import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import NavbarComp from '../components/NavbarComp'
import FooterComp from '../components/FooterComp'
import { Container } from 'react-bootstrap'
import Questionnaire from "../components/Questionnaire"
import { getEssentialQn, updateEssentialQn, essentialQnUpdated } from '../hooks/question'
import { SnackBar } from '../hooks/Common'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    question: state.question,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  getEssentialQn: () => dispatch(getEssentialQn()),
  updateEssentialQn: (data) => dispatch(updateEssentialQn(data)),
  essentialQnUpdated: () => dispatch(essentialQnUpdated()),
  SnackBar: (show, message, variant) => dispatch(SnackBar(show, message, variant))
});

const getAllQuestions = (array) => {
  var check = true
  for (let i = 0; i < array.length; i++) {
    for (let index = 0; index < array[i].questions.length; index++) {
      if (array[i].questions[index].user_answers == null) {
        check = false
      }
      if(array[i].questions[index].type == "company-list" && array[i].questions[index].user_answers !== null && array[i].questions[index].selcted_division == null) {
        var divisions = array[i].questions[index].answers.find((q) => q.id == parseInt(array[i].questions[index].user_answers)).divisions
        if(divisions.length>0) {
          check = false
        }
      }
    }
  }
  return check
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
}

class Onboarding extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      start: null,
      question: null,
      total: null,
      redirect: false,
      shouldNavigate: false,
      path: null
    };
    this.props.getEssentialQn()
  }


  componentDidMount = () => {
    if (this.state.start === null && this.props.question.essential !== null) {
      this.setState({
        question: this.props.question.essential,
        start: 1,
        total: this.props.question.essential.length
      })
    }
    if(this.props.auth.user ===null || (this.props.auth.user !==null && this.props.auth.user.essential_test)) {
      this.setState({
        shouldNavigate: true,
        path: "/dashboard"
      })
    }
  }

  componentDidUpdate = () => {
    if (this.state.start === null && this.props.question.essential !== null) {
      this.setState({
        question: this.props.question.essential,
        start: 1,
        total: this.props.question.essential.length
      })
    }
    if (this.props.question.questionUpdated === "essential") {
      this.props.essentialQnUpdated()
      this.setState({
        shouldNavigate: true,
        path: "/thank-you"
      })
    }
  }


  handleAnswerChange = (parentIndex, childIndex, answer) => {
    this.setState({
      question: Object.values({
        ...this.state.question,
        [parentIndex]: {
          ...this.state.question[parentIndex],
          questions: Object.values({
            ...this.state.question[parentIndex].questions,
            [childIndex]: {
              ...this.state.question[parentIndex].questions[childIndex],
              user_answers: answer
            }
          })
        }
      })
    })
  }

  companyAnswerChange = (parentIndex, childIndex, answer) => {
    this.setState({
      question: Object.values({
        ...this.state.question,
        [parentIndex]: {
          ...this.state.question[parentIndex],
          questions: Object.values({
            ...this.state.question[parentIndex].questions,
            [childIndex]: {
              ...this.state.question[parentIndex].questions[childIndex],
              user_answers: answer,
              selcted_division: null
            }
          })
        }
      })
    })
  }

  handleDivisionAnswerChange = (parentIndex, childIndex, answer) => {
    this.setState({
      question: Object.values({
        ...this.state.question,
        [parentIndex]: {
          ...this.state.question[parentIndex],
          questions: Object.values({
            ...this.state.question[parentIndex].questions,
            [childIndex]: {
              ...this.state.question[parentIndex].questions[childIndex],
              selcted_division: answer
            }
          })
        }
      })
    })
  }

  handleCheckboxChange = (parentIndex, childIndex, answer) => {
    const { question } = this.state

    const user_answers = question[parentIndex].questions[childIndex].user_answers || []

    const updatedUserAnswers = user_answers.includes(answer)
      ? user_answers.filter((id) => id !== answer)
      : [...user_answers, answer];

    this.setState({
      question: question.map((parent, pIndex) => {
        if (pIndex === parentIndex) {
          return {
            ...parent,
            questions: parent.questions.map((child, cIndex) => {
              if (cIndex === childIndex) {
                return {
                  ...child,
                  user_answers: updatedUserAnswers.length !== 0 ? updatedUserAnswers : null,
                }
              }
              return child;
            }),
          };
        }
        return parent;
      })
    })
  }

  handleNext = () => {
    const { question } = this.state
    if (getAllQuestions(question)) {
      this.props.updateEssentialQn(question)
    } else {
      this.props.SnackBar(true, 'Please complete all questions', 'danger')
    }
  }

  handleBack = () => {
    if (this.state.start !== 1) {
      this.setState({ start: this.state.start - 1 })
    }
  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true} />
      <div className="page-sections">
        <div className='onboarding-wrap'>
          <Container>
            <div className='onboarding-contents'>
              <h2 className='main-title-style'>Essential questions</h2>
              <div className='onboarding-questions-list'>
                {this.state.question !== null ? this.state.question.map((data, parentIndex) => {
                  return <Questionnaire
                    allShow={true}
                    parentIndex={parentIndex}
                    data={data}
                    start={this.state.start}
                    handleAnswerChange={(childIndex, answer) => this.handleAnswerChange(parentIndex, childIndex, answer)}
                    handleDivisionAnswerChange={(childIndex, answer) => this.handleDivisionAnswerChange(parentIndex, childIndex, answer)}
                    handleCheckboxChange={(childIndex, answer) => this.handleCheckboxChange(parentIndex, childIndex, answer)}
                    companyAnswerChange={(childIndex, answer) => this.companyAnswerChange(parentIndex, childIndex, answer)}
                  />
                }) : null}
                <div className='onboarding-back-next-btns'>
                  {this.state.start === 1 && this.props.auth.baseline ? <a href='/dashboard' rel="nofollow"> <button className='back-btn'>Back</button></a> :
                     <button className='back-btn onboarding-back-next-disabled'>Back</button>}

                  <button className='next-btn' onClick={this.handleNext}>Next</button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />

    </Fragment>
  }
}

Onboarding.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);
